import { ValueGetterParams } from 'ag-grid-community';

const monthPricePercentGetter = (
  params: ValueGetterParams, // new price
  comparisonMonthPrice: number | null | undefined, // old price
) => {
  const monthPrice = params.data?.monthPrice;

  const comparisonMonthPricePercent =
    comparisonMonthPrice && monthPrice
      ? (
          ((monthPrice - comparisonMonthPrice) /
            comparisonMonthPrice) *
          100
        ).toFixed(2)
      : null;

  return comparisonMonthPricePercent;
};

export default monthPricePercentGetter;
